
type TProps = {
  svgPaths: Array<string>,
  className: string
};

function Icon({ svgPaths = [], className }: TProps) {
  return (
    <svg
      aria-hidden
      role='presentation'
      viewBox='0 0 1024 1024'
      className={className}
    >
      {svgPaths.length && <path d={svgPaths} />}
    </svg>
  );
}

export default Icon;
